/// <amd-module name="Wit/DeliveryPlans/Board/Graph/Contracts" />

// Represents a point on a 2D surface
export interface IPoint {
    x: number;

    y: number;
}

export enum Position {
    Above = "Above",
    Below = "Below",
    Left = "Left",
    Right = "Right"
}

export namespace Constants {
    export const verticalDisplacement = 30;

    /**
     * If the distance in pixels between the target and source card are greater than
     * this value, we won't randomly displace the line
     */
    export const horizontalDisplacementThreshold = 40;

    /**
     * Represents the range of values by which a line can be replaced
     */
    export const horizontalDisplacementRange = 30;
}
